function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
import _isEmpty from 'lodash/isEmpty';

/**
 * Applies or removes a class on elements with specified class names based on a given condition.
 *
 * @param {boolean} condition - The condition that determines whether the class should be added or removed.
 * @param {string} className - The class name to apply or remove based on the condition.
 * @param {Array<string>} targetClassNames - Class names of target elements.
 */
export function applyClassToExistingElements(condition, className, targetClassNames) {
  if (_isEmpty(targetClassNames)) {
    return;
  }
  targetClassNames.forEach(function (targetClassName) {
    var elements = document.getElementsByClassName(targetClassName);

    // eslint-disable-next-line no-restricted-syntax
    var _iterator = _createForOfIteratorHelper(elements),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var element = _step.value;
        if (condition) {
          element.classList.add(className);
        } else {
          element.classList.remove(className);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
}

/**
 * Recursively applies or removes a class on matching child nodes.
 *
 * @param {boolean} condition - Condition to apply or remove the class.
 * @param {string} className - Class name to apply or remove.
 * @param {Array<string>} targetClassNames - Class names of target elements.
 */
export function applyClassToMatchingChildren(condition, className, targetClassNames) {
  if (_isEmpty(targetClassNames)) {
    return function () {
      return null;
    };
  }
  return function checkAndApply(node) {
    if (node.nodeType === 1) {
      // Ensure it's an element node
      if (targetClassNames.some(function (aClassName) {
        return node.classList.contains(aClassName);
      })) {
        if (condition) {
          node.classList.add(className);
        } else {
          node.classList.remove(className);
        }
      }
      node.childNodes.forEach(checkAndApply);
    }
  };
}